import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import api_services from "../../../src/services/api_services";
import auth_service from "../../../src/services/auth_service";
import axios from "axios";
import CouponModal from "./CouponModal";
import AddAddress from "../Account/AddAddress";
import toast from "react-hot-toast";
import { useCart } from "../../context/CartContext";
import PrescriptionModal from "../../components/PrescriptionModal";
const Cart = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [orderCount, setOrderCount] = useState(0);
  const imageBaseURL = "https://newpos.spectsgenie.com/";
  const BASE_URL = `${process.env.REACT_APP_HOST_URL}`;
  const [isCouponModalOpen, setCouponModalOpen] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [totalAmt, setTotalAmt] = useState(0);
  const [originalTotalAmt, setOriginalTotalAmt] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const { setCartCount } = useCart();
  const [userData, setUserData] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [showBundleOffer, setShowBundleOffer] = useState(false);
  const [hasGenieSolution, setHasGenieSolution] = useState(false);
  const [showAddSolution, setShowAddSolution] = useState(false);
  const [bundleOfferData, setBundleOfferData] = useState(null);
  const [appliedPoints, setAppliedPoints] = useState(0);
  const [pointsToUse, setPointsToUse] = useState(0);
  const [availablePoints, setAvailablePoints] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [useWalletPoints, setUseWalletPoints] = useState(false);
  const [showPrescriptionSelector, setShowPrescriptionSelector] = useState(false);
  const [selectedProductForPrescription, setSelectedProductForPrescription] = useState(null);
  const [productPrescriptions, setProductPrescriptions] = useState({});
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [selectedPrescriptionData, setSelectedPrescriptionData] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState('');
  let isLoggedIn = false;
  let customerId;
  try {
    const { id } = auth_service.getAccessTokenData();
    isLoggedIn = true;
    customerId = id;
  } catch (error) {
    console.log("Error getting access token:", error);
    isLoggedIn = false;
  }
  const fetchCartData = async () => {
    if (!isLoggedIn) {
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      const response = await api_services.fetchLocalCartData(localCart);
      setCartCount(localCart.length);
      const mergedProducts = localCart.map((localItem) => {
        const responseProduct = response.data.find(
          (apiProduct) =>
            String(apiProduct.product_id) === String(localItem.product_id)
        );
        if (responseProduct) {
          const quantity = localItem.quantity || 1;
          // Fix: Use the correct price field from the API response
          const price_without_gst = parseFloat(
            responseProduct.contact_lens_price ||
              responseProduct.price ||
              localItem.price ||
              0
          );
          const price_with_gst =
            responseProduct.ca_id === "3" || responseProduct.ca_id === 3
              ? price_without_gst
              : price_without_gst * 1.18;
          return {
            ...responseProduct,
            quantity,
            price_with_gst,
            price_without_gst,
            total_price:
              responseProduct.ca_id === "3" || responseProduct.ca_id === 3
                ? quantity * price_without_gst
                : quantity * price_with_gst,
          };
        } else {
          // Fallback to localStorage data
          const quantity = localItem.quantity || 1;
          const price_without_gst = parseFloat(localItem.price || 0);
          const price_with_gst =
            localItem.ca_id === "3" || localItem.ca_id === 3
              ? price_without_gst
              : price_without_gst * 1.18;
          return {
            ...localItem,
            quantity,
            price_with_gst,
            price_without_gst,
            total_price:
              localItem.ca_id === "3" || localItem.ca_id === 3
                ? quantity * price_without_gst
                : quantity * price_with_gst,
          };
        }
      });
      setProducts(mergedProducts);
      // Load prescription data for localStorage cart
      const prescriptionData = {};
      localCart.forEach(item => {
        if (item.prescription_data) {
          prescriptionData[item.product_id] = item.prescription_data;
        }
      });
      setProductPrescriptions(prescriptionData);
      // Recalculate amounts after setting products
      if (mergedProducts.length > 0) {
        const totalPrice = mergedProducts.reduce((sum, item) => {
          const isContactLens = String(item.ca_id) === "3";
          const itemPrice = isContactLens
            ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
            : parseFloat(item.price_with_gst || item.price || 0);
          const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
          return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
        }, 0);
        setOriginalTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
        setTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
        setFinalAmount(isNaN(totalPrice) ? 0 : totalPrice);
      }
      return;
    } else {
      try {
        const response = await api_services.fetchCartProductsById(customerId);
        setCartCount(response.data.length);
        const fetchedProducts = response.data.map((item) => {
          const quantity = item.cart_quantity || 1;
          const price_without_gst = parseFloat(item.price || 0);
          const price_with_gst =
            item.ca_id === "3" || item.ca_id === 3
              ? price_without_gst
              : price_without_gst * 1.18;
          return {
            ...item,
            quantity,
            price_with_gst,
            price_without_gst,
            total_price:
              item.ca_id === "3" || item.ca_id === 3
                ? quantity * price_without_gst
                : quantity * price_with_gst,
          };
        });
        setProducts(fetchedProducts);
        // Recalculate amounts after setting products for logged-in users
        if (fetchedProducts.length > 0) {
          const totalPrice = fetchedProducts.reduce((sum, item) => {
            const isContactLens = String(item.ca_id) === "3";
            const itemPrice = isContactLens
              ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
              : parseFloat(item.price_with_gst || item.price || 0);
            const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
            return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
          }, 0);
          setOriginalTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
          setTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
          setFinalAmount(isNaN(totalPrice) ? 0 : totalPrice);
        }
        // Load prescription data for logged-in users
        const prescriptionData = {};
        fetchedProducts.forEach(item => {
          if (item.prescription && item.prescription.trim() !== '') {
            try {
              // Parse the JSON string prescription data
              const parsedPrescription = JSON.parse(item.prescription);
              prescriptionData[item.id] = parsedPrescription;
            } catch (error) {
              console.error("Error parsing prescription ", error);
            }
          }
        });
        setProductPrescriptions(prescriptionData);
      } catch (error) {
        console.error("Error fetching cart ", error);
        setProducts([]);
      }
    }
  };
  const updateCartQuantityAPI = async (itemId, newQuantity) => {
    try {
      const payload = { id: itemId, quantity: newQuantity };
      const response = await api_services.updateCartQuantity(payload);
      if (response.success) {
        return true;
      }
      // toast.error("Failed to update quantity. Please try again.");
      return false;
    } catch (error) {
      console.error("Error updating cart quantity:", error);
      // toast.error("Failed to update quantity. Please try again.");
      return false;
    }
  };
  useEffect(() => {
    // Initialize pricing states to prevent undefined errors
    setOriginalTotalAmt(0);
    setTotalAmt(0);
    setFinalAmount(0);
    setAppliedPoints(0);
    fetchCartData();
    if (isLoggedIn) {
      fetchAddresses();
      fetchUserDetails();
    }
  }, []);
  // Check for bundle offers when products or total amount changes
  useEffect(() => {
    if (products.length > 0 && originalTotalAmt > 0) {
      checkBundleOffers();
    }
  }, [products, originalTotalAmt]);
  // Reset preventAutoApply if cart is empty
  useEffect(() => {
    if (products.length === 0) {
      localStorage.removeItem('preventAutoApply');
    }
  }, [products]);

  // --- FIX: New useEffect hook to remove any coupon (auto-applied or manual) ---
  // --- when there are no longer any non-sale products eligible for it ---
  useEffect(() => {
    // Only check if a coupon is currently applied
    if (appliedCoupon && products.length > 0) {
      // Determine the products this coupon was applied to
      let couponEligibleProducts = products;

      // If the coupon is category-specific, filter products by that category
      if (appliedCoupon.ca_id !== null && appliedCoupon.ca_id !== undefined && appliedCoupon.ca_id !== "") {
        couponEligibleProducts = products.filter(
          (product) => String(product.ca_id) === String(appliedCoupon.ca_id)
        );
      }

      // Check if there are any non-sale products among the eligible ones
      const hasNonSaleEligibleProducts = couponEligibleProducts.some(
        (product) =>
          product.on_sale !== 1 &&
          product.on_sale !== '1' &&
          product.on_sale !== true &&
          product.on_sale !== 'true'
      );

      // If there are no non-sale products left that the coupon applies to, remove the coupon
      if (!hasNonSaleEligibleProducts) {
        console.log("Removing coupon because no eligible non-sale products remain.");
        removeCoupon();
      }
    }
  }, [products, appliedCoupon]); // Depend on products and appliedCoupon
  // --- END OF FIX ---

  // Auto-apply new customer coupon when products change
  useEffect(() => {
    if (products.length > 0 && isNewCustomer && !appliedCoupon) {
      autoApplyNewCustomerCoupon();
    }
  }, [products, isNewCustomer, appliedCoupon]);
  const fetchAddresses = async () => {
    try {
      const response = await api_services.fetchAddressById(customerId);
      setAddresses(response.data);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };
  const fetchUserDetails = async () => {
    try {
      const response = await api_services.fetchProfileDetails(customerId);
      setUserData(response.data[0]);
      // Set available points from wallet
      const walletPoints = parseInt(response.data[0]?.wallet || 0, 10);
      setAvailablePoints(walletPoints);
      // Check if customer is new by fetching actual orders
      try {
        const ordersResponse = await api_services.fetchOrdersById(customerId);
        const hasOrders = ordersResponse.data && ordersResponse.data.length > 0;
        setIsNewCustomer(!hasOrders);
      } catch (orderError) {
        console.log("No orders found, treating as new customer");
        setIsNewCustomer(true);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };
  // Check for bundling offers and solutions
  const checkBundleOffers = async () => {
    const totalAmount = originalTotalAmt;
    const hasLensSolution = products.some(product =>
      product.name?.toLowerCase().includes('lens cleaning solution') ||
      product.product_name?.toLowerCase().includes('lens cleaning solution')
    );
    setHasGenieSolution(hasLensSolution);
    try {
      // Fetch bundle offers from API
      const response = await api_services.fetchBundleOffers();
      if (response.success && response.data && response.data.length > 0) {
        // Find the lens cleaning solution product (id = 2)
        const lensSolutionOffer = response.data.find(offer => offer.id === 2);
        if (lensSolutionOffer && totalAmount >= 2000) {
          setShowBundleOffer(true);
          setBundleOfferData({
            type: 'paid',
            message: `Add ${lensSolutionOffer.p_name} for just ₹${lensSolutionOffer.dis_p_price}`,
            value: parseFloat(lensSolutionOffer.dis_p_price),
            productName: lensSolutionOffer.p_name,
            productId: lensSolutionOffer.id,
            productData: lensSolutionOffer,
            original_price: lensSolutionOffer.p_price,
            discount: Math.round(((parseFloat(lensSolutionOffer.p_price) - parseFloat(lensSolutionOffer.dis_p_price)) / parseFloat(lensSolutionOffer.p_price)) * 100)
          });
        } else {
          setShowAddSolution(false);
          setShowBundleOffer(false);
          setBundleOfferData(null);
        }
      }
    } catch (error) {
      console.error("Error fetching bundle offers:", error);
      // Fallback to hardcoded values if API fails
    }
  };
  // Auto-apply new customer coupon
  const autoApplyNewCustomerCoupon = () => {
    console.log('autoApplyNewCustomerCoupon called (from effect or user action)');
    console.log('autoApplyNewCustomerCoupon called');
    // Check if auto-apply is prevented in localStorage
    const preventAutoApply = localStorage.getItem('preventAutoApply') === 'true';
    console.log('preventAutoApply:', preventAutoApply);
    console.log('isNewCustomer:', isNewCustomer);
    console.log('appliedCoupon:', appliedCoupon);
    console.log('products count:', products.length);
    if (isNewCustomer && !appliedCoupon && products.length > 0 && !preventAutoApply) {
      console.log('Conditions met, checking for non-sale products...');
      // Log all products and their on_sale status for debugging
      console.log('All products with on_sale status:', products.map(p => ({
        id: p.id || p.product_id,
        name: p.name || p.product_name,
        on_sale: p.on_sale,
        type: typeof p.on_sale
      })));
      // Get all products that are not on sale (handle both string '1' and number 1, and undefined/null cases)
      const nonSaleProducts = products.filter(product => {
        const isNotOnSale = product.on_sale !== 1 &&
                          product.on_sale !== '1' &&
                          product.on_sale !== 'true' &&
                          product.on_sale !== true;
        console.log(`Product ${product.id || product.product_id} - on_sale: ${product.on_sale}, type: ${typeof product.on_sale}, isNotOnSale: ${isNotOnSale}`);
        return isNotOnSale;
      });
      console.log('Non-sale products found:', nonSaleProducts.length);
      // Only proceed if there are non-sale products in the cart
      if (nonSaleProducts.length > 0) {
        console.log('Proceeding with auto-apply for non-sale products');
        // Get unique category IDs of non-sale products
        const categoryIds = [...new Set(nonSaleProducts.map(p => p.ca_id))];
        console.log('Category IDs of non-sale products:', categoryIds);
        const newCustomerCoupon = {
          id: 'auto-new-customer',
          code: 'GENIENEW',
          value: 10,
          isPercentage: true,
          // If all non-sale products are from the same category, apply to that category
          // Otherwise, apply to all products (ca_id: null)
          ca_id: categoryIds.length === 1 ? categoryIds[0] : null,
          requiresLogin: false,
          // Track which products this coupon should apply to
          applicableProductIds: nonSaleProducts.map(p => p.id || p.product_id),
          isAutoApplied: true
        };
        setTimeout(() => {
          applyCoupon(newCustomerCoupon);
          // toast.success('🎉 Welcome! New customer discount applied automatically!', {
          //   duration: 4000,
          //   position: 'top-center',
          //   style: {
          //     background: '#10B981',
          //     color: '#fff',
          //     fontWeight: 'bold'
          // }
          // });
        }, 1000);
      }
    }
  };
  // Add lens cleaning solution to cart
  const addLensCleaningSolution = async () => {
    // Use the bundle offer data from API if available, otherwise fallback to default values
    const price = bundleOfferData?.value;
    const productName = bundleOfferData?.productName;
    const productId = bundleOfferData?.productId;
    const productData = bundleOfferData?.productData || null;
    // Create the product object using API data if available
    const solutionProduct = productData ? {
      product_id: productData.id.toString(),
      ca_id: '4', // Accessories category
      name: productData.p_name,
      price: parseFloat(productData.dis_p_price),
      price_without_gst: parseFloat(productData.dis_p_price),
      price_with_gst: parseFloat(productData.dis_p_price),
      quantity: 1,
      total_price: parseFloat(productData.dis_p_price),
      pr_image: productData.image_url,
      image_url: productData.image_url,
      is_bundle_offer: true,
      is_free_offer: false,
      offer_name: productData.offer_name,
      p_desc: productData.p_desc
    } : {
      product_id: productId,
      ca_id: '4', // Accessories category
      name: productName,
      price: price,
      price_without_gst: price,
      price_with_gst: price,
      quantity: 1,
      total_price: price,
      pr_image: 'lens-cleaning-solution.jpg',
      is_bundle_offer: true,
      is_free_offer: false
    };
    const updatedProducts = [...products, solutionProduct];
    setProducts(updatedProducts);
    // Update localStorage for non-logged-in users
    if (!isLoggedIn) {
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      localCart.push(solutionProduct);
      localStorage.setItem("cart", JSON.stringify(localCart));
      setCartCount(localCart.length);
    }
    setHasGenieSolution(true);
    setShowAddSolution(false);
    setShowBundleOffer(false);
    // toast.success(`₹${price} ${productName} added to cart!`, {
    //   duration: 3000,
    //   position: 'top-center',
    //   style: {
    //     background: '#10B981',
    //     color: '#fff'
    //   }
    // });
  };
  // const handleCouponModal = () => {
  //   console.log("handleCouponModal called, current state:", isCouponModalOpen);
  //   if (!appliedCoupon) {
  //     setCouponModalOpen(!isCouponModalOpen);
  //     console.log("Setting modal open to:", !isCouponModalOpen);
  //   } else {
  //     toast.error(
  //       "A coupon has already been applied. Remove it to apply another."
  //     );
  //   }
  // };
  const applyCoupon = (coupon) => {
    if (appliedCoupon) {
      toast.error("A coupon has already been applied.");
      return;
    }
    // Handle auto-applied coupons for new customers (non-sale products only)
    if (coupon.isAutoApplied && coupon.applicableProductIds) {
      // Calculate total only for applicable non-sale products
      const categoryTotal = products
        .filter(product =>
          coupon.applicableProductIds.includes(product.id || product.product_id)
        )
        .reduce((sum, item) => {
          const isContactLens = String(item.ca_id) === "3";
          const itemPrice = isContactLens
            ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
            : parseFloat(item.price_with_gst || item.price || 0);
          const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
          return sum + itemPrice * quantity;
        }, 0);
      if (categoryTotal === 0) {
        return;
      }
      // Calculate discount for non-sale products only
      const discount = coupon.isPercentage
        ? (categoryTotal * parseFloat(coupon.value)) / 100
        : Math.min(parseFloat(coupon.value), categoryTotal);
      const safeDiscount = isNaN(discount) ? 0 : discount;
      const safeCategoryTotal = isNaN(categoryTotal) ? 0 : categoryTotal;
      setAppliedCoupon({
        ...coupon,
        discount: safeDiscount,
        categoryTotal: safeCategoryTotal,
        applicableProducts: coupon.applicableProductIds.length,
        isAutoApplied: true
      });
      return;
    }
    // Original coupon application logic for regular coupons
    const categoryTotal = coupon.ca_id === null || coupon.ca_id === "" || coupon.ca_id === undefined
      ? originalTotalAmt
      : products
          .filter((product) => String(product.ca_id) === String(coupon.ca_id))
          .reduce((sum, item) => {
            const isContactLens = String(item.ca_id) === "3";
            const itemPrice = isContactLens
              ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
              : parseFloat(item.price_with_gst || item.price || 0);
            const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
            return sum + itemPrice * quantity;
          }, 0);
    if (categoryTotal === 0) {
      return;
    }
    const discount = coupon.isPercentage
      ? (categoryTotal * parseFloat(coupon.value)) / 100
      : Math.min(parseFloat(coupon.value), categoryTotal);
    const safeDiscount = isNaN(discount) ? 0 : discount;
    const safeCategoryTotal = isNaN(categoryTotal) ? 0 : categoryTotal;
    setAppliedCoupon({
      ...coupon,
      discount: safeDiscount,
      categoryTotal: safeCategoryTotal,
      applicableProducts: coupon.ca_id === null || coupon.ca_id === "" || coupon.ca_id === undefined
        ? products.length
        : products.filter((p) => String(p.ca_id) === String(coupon.ca_id)).length,
    });
    setCouponModalOpen(false);
  };
  const removeCoupon = () => {
  console.log('removeCoupon called!');
    if (appliedCoupon) {
      // Reset coupon related states
      const wasAutoApplied = appliedCoupon.isAutoApplied;
      setAppliedCoupon(null);
      setCouponCode("");
      // If it was an auto-applied coupon, prevent it from being auto-applied again
      if (wasAutoApplied) {
        localStorage.setItem('preventAutoApply', 'true');
      }
      // Recalculate the total without the coupon
      const totalPrice = products.reduce((sum, item) => {
        const isContactLens = String(item.ca_id) === "3";
        const itemPrice = isContactLens
          ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
          : parseFloat(item.price_without_gst || item.price || 0);
        const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
        return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
      }, 0);
      // Calculate final amount considering any applied points
      const finalAmountAfterPoints = appliedPoints > 0
        ? Math.max(0, totalPrice - appliedPoints)
        : totalPrice;
      // Update all amount states
      setOriginalTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
      setTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
      setFinalAmount(isNaN(finalAmountAfterPoints) ? 0 : finalAmountAfterPoints);
      // toast.success("Coupon removed successfully!", {
      //   duration: 2000,
      //   position: 'top-center',
      //   style: {
      //     background: '#10B981',
      //     color: '#fff'
      //   }
      // });
    }
  };
  // Points functionality
  const applyPoints = () => {
    if (pointsToUse > 0 && pointsToUse <= availablePoints) {
      // Use current totalAmt which already includes coupon discount if any
      const maxPointsUsable = Math.min(pointsToUse, totalAmt);
      setAppliedPoints(maxPointsUsable);
      setPointsToUse(0);
      // Update final amount based on current total amount (after coupon discount)
      const newFinalAmount = Math.max(0, totalAmt - maxPointsUsable);
      setFinalAmount(newFinalAmount);
      // toast.success(`₹${maxPointsUsable} SG-Wallet points applied!`, {
      //   duration: 3000,
      //   position: 'top-center',
      //   style: {
      //     background: '#10B981',
      //     color: '#fff'
      //   }
      // });
    }
  };
  const removePoints = () => {
    setAppliedPoints(0);
    setUseWalletPoints(false);
    // Use current totalAmt which already includes coupon discount if any
    setFinalAmount(totalAmt);
    // toast.success("Points removed successfully!", {
    //   duration: 2000,
    //   position: 'top-center',
    //   style: {
    //     background: '#10B981',
    //     color: '#fff'
    //   }
    // });
  };
  const handlePointsInputChange = (e) => {
    const value = parseInt(e.target.value, 10) || 0;
    const maxUsable = Math.min(value, availablePoints, totalAmt);
    setPointsToUse(value > maxUsable ? maxUsable : value);
  };
  // Handle wallet points checkbox change
  const handleWalletPointsChange = (e) => {
    const isChecked = e.target.checked;
    setUseWalletPoints(isChecked);
    if (isChecked) {
      toast.success("SG-Wallet points will be applied!", {
        duration: 3000,
        position: 'top-center',
        style: {
          background: '#10B981',
          color: '#fff'
        }
      });
    } else {
      toast.success("Points removed successfully!", {
        duration: 2000,
        position: 'top-center',
        style: {
          background: '#10B981',
          color: '#fff'
        }
      });
    }
  };
  const handlePayment = async () => {
    if (!isLoggedIn) {
      // Redirect to signin page with current cart page as redirect target
      navigate('/signin', {
        state: {
          from: '/cart',
          message: 'Please login to proceed with checkout'
        }
      });
      return;
    }
    const { userName, id: userId } = auth_service.getAccessTokenData();
    if (
      !userData?.mobile ||
      userData.mobile.trim() === "" ||
      !userData?.email ||
      userData.email.trim() === ""
    ) {
      toast.error(
        "Please update your mobile number and email in profile account information before placing an order."
      );
      return;
    }
    let data = {
      name: userName,
      mobileNumber: userData.mobile,
      amount: Math.round(finalAmount),
      userId: userId,
      userNumber: userData.mobile,
      userEmail: userData.email,
      orderData: products,
      addressId: selectedAddress.id,
    };
    if (appliedCoupon) {
      data.discountCode = appliedCoupon.code;
      data.couponCategoryId = appliedCoupon.ca_id;
      data.couponDiscount = appliedCoupon.discount;
    }
    if (appliedPoints > 0) {
      data.pointsUsed = appliedPoints;
      data.walletPointsDiscount = appliedPoints;
    }
    try {
      let isFirstOrder = false;
      // Check if this is customer's first order before placing the order
      try {
        const orderHistoryResponse = await api_services.checkCustomerOrderHistory(userId);
        isFirstOrder = !orderHistoryResponse.hasOrders; // Assuming the API returns { hasOrders: boolean }
      } catch (orderHistoryError) {
        console.warn("Could not check order history, assuming not first order:", orderHistoryError);
        // If API is not available, fallback to checking current orders count
        isFirstOrder = orderCount === 0;
      }
      const response = await axios.post(
        `${BASE_URL}/api/phonepe/create-order`,
        data
      );
      if (response && response.data?.url) {
        // If payment URL is created successfully and this is first order,
        // we'll update membership status after payment success
        // For now, store the first order flag in sessionStorage to use after payment success
        if (isFirstOrder) {
          sessionStorage.setItem('isFirstOrder', 'true');
          sessionStorage.setItem('customerId', userId);
        }
        // Store wallet points data for updating after successful payment
        if (appliedPoints > 0) {
          const remainingPoints = availablePoints - appliedPoints;
          sessionStorage.setItem('walletPointsUsed', appliedPoints.toString());
          sessionStorage.setItem('remainingWalletPoints', remainingPoints.toString());
          sessionStorage.setItem('updateWalletAfterPayment', 'true');
        }
        window.location.href = response.data.url;
      } else {
        toast.error("Payment failed. Please try again.");
      }
    } catch (error) {
      console.error("Error in payment:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };
  // Comprehensive pricing calculation function
  const recalculateAllAmounts = () => {
    if (!Array.isArray(products) || products.length === 0) {
      setOriginalTotalAmt(0);
      setTotalAmt(0);
      setFinalAmount(0);
      setAppliedPoints(0);
      return;
    }
    // Calculate original total from all products
    const totalPrice = products.reduce((sum, item) => {
      const isContactLens = String(item.ca_id) === "3";
      const itemPrice = isContactLens
        ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
        : parseFloat(item.price_with_gst || item.price || 0);
      const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
      return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
    }, 0);
    setOriginalTotalAmt(isNaN(totalPrice) ? 0 : totalPrice);
    let finalTotal = totalPrice;
    let couponDiscount = 0;
    // Apply coupon discount if exists
    if (appliedCoupon) {
      // Get all products that match the coupon's category (if any) and are not on sale
      const eligibleProducts = products.filter(item => {
        // Check if product is in the right category (or no category specified)
        const categoryMatch = !appliedCoupon.ca_id ||
                            String(item.ca_id) === String(appliedCoupon.ca_id);
        // Check if product is not on sale
        const notOnSale = item.on_sale !== 1 && item.on_sale !== '1';
        return categoryMatch && notOnSale;
      });
      // Calculate total for eligible products only
      const eligibleTotal = eligibleProducts.reduce((sum, item) => {
        const isContactLens = String(item.ca_id) === "3";
        const itemPrice = isContactLens
          ? parseFloat(item.price_without_gst || item.contact_lens_price || item.price || 0)
          : parseFloat(item.price_with_gst || item.price || 0);
        const quantity = parseInt(item.quantity || item.cart_quantity || 1, 10);
        return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
      }, 0);
      // Only apply coupon if there are eligible products
      if (eligibleTotal > 0) {
        // Calculate discount based on the eligible products only
        const pct = parseFloat(appliedCoupon.value);
        let computed = appliedCoupon.isPercentage
          ? (eligibleTotal * (isNaN(pct) ? 0 : pct)) / 100
          : Math.min(parseFloat(appliedCoupon.value) || 0, eligibleTotal);

        // Apply max discount cap if provided
        const maxCap = appliedCoupon.max_discount !== null && appliedCoupon.max_discount !== undefined
          ? parseFloat(appliedCoupon.max_discount)
          : null;
        if (!isNaN(maxCap) && maxCap > 0) {
          computed = Math.min(computed, maxCap);
        }

        couponDiscount = computed;
        // Update the applied coupon with the correct details (use capped value)
        setAppliedCoupon(prev => ({
          ...prev,
          discount: couponDiscount,
          applicableProducts: eligibleProducts.length,
          categoryTotal: eligibleTotal
        }));
      }
      finalTotal = totalPrice - couponDiscount;
    }
    const safeFinalTotal = isNaN(finalTotal) ? 0 : Math.max(0, finalTotal);
    setTotalAmt(safeFinalTotal);
    // Apply wallet points if enabled
    let pointsDiscount = 0;
    if (useWalletPoints && availablePoints > 0 && safeFinalTotal > 0) {
      pointsDiscount = Math.min(availablePoints || 0, safeFinalTotal);
      setAppliedPoints(isNaN(pointsDiscount) ? 0 : pointsDiscount);
    } else {
      setAppliedPoints(0);
    }
    // Set final amount after all discounts
    const finalAmountAfterAllDiscounts = Math.max(0, safeFinalTotal - (pointsDiscount || 0));
    setFinalAmount(isNaN(finalAmountAfterAllDiscounts) ? 0 : finalAmountAfterAllDiscounts);
  };
  // Use a ref to track if this is the initial render
  const isInitialMount = React.useRef(true);
  // Effect to handle bottom navbar visibility when address modal is open/closed
  useEffect(() => {
    const bottomNav = document.querySelector('.bottom-navbar');
    if (bottomNav) {
      if (isModalOpen) {
        bottomNav.style.display = 'none';
      } else {
        bottomNav.style.display = 'flex';
      }
    }
    // Cleanup function to ensure navbar is shown when component unmounts
    return () => {
      const bottomNav = document.querySelector('.bottom-navbar');
      if (bottomNav) {
        bottomNav.style.display = 'flex';
      }
    };
  }, [isModalOpen]);
  // Main useEffect for recalculating amounts when products change
  useEffect(() => {
    // Only recalculate if products is properly initialized as an array
    if (Array.isArray(products) && products.length > 0) {
      // Skip the initial render to prevent double calculation
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        recalculateAllAmounts();
      }
    }
  }, [products, useWalletPoints, availablePoints, appliedCoupon?.code]); // Only depend on coupon code instead of the whole object
  const handleRemove = async (item) => {
    // Check if the product has a prescription file that needs to be deleted
    try {
      const prescriptionData = item.prescription_data || 
        (item.prescription ? JSON.parse(item.prescription) : null);
      
      // If there's a prescription file path, delete the file
      if (prescriptionData?.prescriptionFilePath) {
        try {
          await api_services.deletePrescriptionFile(prescriptionData.prescriptionFilePath);
          console.log('Prescription file deleted successfully');
        } catch (error) {
          console.error('Error deleting prescription file:', error);
          // Continue with removal even if file deletion fails
        }
      }
    } catch (error) {
      console.error('Error processing prescription data during removal:', error);
    }

    // Check if it's a bundle offer item
    if (item.is_bundle_offer) {
      // Remove from products state directly for bundle offer items
      const updatedProducts = products.filter(
        (product) => !(String(product.product_id) === String(item.product_id) && product.is_bundle_offer)
      );
      setProducts(updatedProducts);
      // Update local storage for non-logged in users
      if (!isLoggedIn) {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        const updatedCart = localCart.filter(
          (data) => !(String(data.product_id) === String(item.product_id) && data.is_bundle_offer)
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        setCartCount(updatedCart.length);
      }
      // Update bundle offer visibility
      setHasGenieSolution(false);
      setShowBundleOffer(true);
      // toast.success("Bundle offer item removed successfully!");
      return;
    }
    // Handle regular cart items
    let updatedProducts;
    if (!isLoggedIn) {
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      const updatedCart = localCart.filter(
        (data) =>
          String(data.product_id) !== String(item.product_id) ||
          String(data.ca_id) !== String(item.ca_id)
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      setCartCount(updatedCart.length);
      // Update products state immediately to reflect the removal
      updatedProducts = products.filter(
        (product) =>
          String(product.product_id) !== String(item.product_id) ||
          String(product.ca_id) !== String(item.ca_id)
      );
      setProducts(updatedProducts);
    } else {
      try {
        const response = await api_services.deleteFromCart(item.id);
        if (response.success) {
          await fetchCartData();
          // Get updated products after API call
          updatedProducts = products.filter(
            (product) => String(product.id) !== String(item.id)
          );
        } else {
          return; // Exit if deletion failed
        }
      } catch (error) {
        console.error("Error during deletion:", error);
        toast.error("Failed to remove item. Please try again.");
        return; // Exit if deletion failed
      }
    }
    // Auto-remove bundle offer logic after successful removal
    setTimeout(() => {
      // Check if cart is empty or calculate total amount of remaining non-bundle products
      const nonBundleProducts = updatedProducts.filter(product => !product.is_bundle_offer);
      // If no products left in cart, remove bundle offers
      if (nonBundleProducts.length === 0) {
        removeBundleOffers("No products in cart");
        return;
      }
      // Calculate total amount of non-bundle products
      const totalAmount = nonBundleProducts.reduce((sum, product) => {
        const isContactLens = String(product.ca_id) === "3";
        const itemPrice = isContactLens
          ? parseFloat(product.price_without_gst || product.contact_lens_price || product.price || 0)
          : parseFloat(product.price_with_gst || product.price || 0);
        const quantity = parseInt(product.quantity || product.cart_quantity || 1, 10);
        return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
      }, 0);
      // If total amount is less than 2000, remove bundle offers
      if (totalAmount < 2000) {
        removeBundleOffers("Total amount less than ₹2000");
      }
    }, 100); // Small delay to ensure state updates are processed
  };
  // Helper function to check bundle offer conditions
  const checkBundleOfferConditions = (updatedProducts) => {
    setTimeout(() => {
      // Filter out bundle offers to calculate total of regular products only
      const nonBundleProducts = updatedProducts.filter(product => !product.is_bundle_offer);
      // If no regular products left in cart, remove bundle offers
      if (nonBundleProducts.length === 0) {
        removeBundleOffers("No products in cart");
        return;
      }
      // Calculate total amount of non-bundle products
      const totalAmount = nonBundleProducts.reduce((sum, product) => {
        const isContactLens = String(product.ca_id) === "3";
        const itemPrice = isContactLens
          ? parseFloat(product.price_without_gst || product.contact_lens_price || product.price || 0)
          : parseFloat(product.price_with_gst || product.price || 0);
        const quantity = parseInt(product.quantity || product.cart_quantity || 1, 10);
        return sum + (isNaN(itemPrice) ? 0 : itemPrice) * (isNaN(quantity) ? 1 : quantity);
      }, 0);
      // If total amount is less than 2000, remove bundle offers
      if (totalAmount < 2000) {
        removeBundleOffers("Total amount less than ₹2000");
      }
    }, 100); // Small delay to ensure state updates are processed
  };
  // Helper function to remove bundle offers
  const removeBundleOffers = (reason) => {
    const currentProducts = !isLoggedIn
      ? JSON.parse(localStorage.getItem("cart")) || []
      : products;
    const bundleOffers = currentProducts.filter(product => product.is_bundle_offer);
    if (bundleOffers.length > 0) {
      if (!isLoggedIn) {
        // Remove bundle offers from localStorage
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        const updatedCart = localCart.filter(data => !data.is_bundle_offer);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        setCartCount(updatedCart.length);
        // Update products state
        const updatedProducts = products.filter(product => !product.is_bundle_offer);
        setProducts(updatedProducts);
      } else {
        // For logged-in users, remove bundle offers from products state
        const updatedProducts = products.filter(product => !product.is_bundle_offer);
        setProducts(updatedProducts);
      }
      // Update bundle offer visibility
      setHasGenieSolution(false);
      setShowBundleOffer(false);
      setBundleOfferData(null);
      toast.success(`Bundle offer removed: ${reason}`, {
        duration: 3000,
        position: "top-center",
        style: {
          background: "#f59e0b",
          color: "#fff",
        },
      });
    }
  };
  const handleSelect = (address) => {
    setSelectedAddress(address);
  };
  const handleSaveAddress = () => {
    fetchAddresses();
  };
  const handleIncrease = async (index) => {
    const updatedProducts = [...products];
    updatedProducts[index].quantity =
      parseInt(updatedProducts[index].quantity || 1, 10) + 1;
    const isContactLens = String(updatedProducts[index].ca_id) === "3";
    updatedProducts[index].total_price =
      updatedProducts[index].quantity *
      (isContactLens
        ? parseFloat(updatedProducts[index].price_without_gst || 0)
        : parseFloat(updatedProducts[index].price_with_gst || 0));
    if (!isLoggedIn) {
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      const updatedCart = localCart.map((cartItem) =>
        String(cartItem.product_id) ===
        String(updatedProducts[index].product_id)
          ? { ...cartItem, quantity: updatedProducts[index].quantity }
          : cartItem
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const success = await updateCartQuantityAPI(
        updatedProducts[index].id,
        updatedProducts[index].quantity
      );
      if (!success) return;
    }
    setProducts(updatedProducts);
    // Check bundle offer conditions after quantity increase
    checkBundleOfferConditions(updatedProducts);
  };
  const handleDecrease = async (index) => {
    const updatedProducts = [...products];
    if (parseInt(updatedProducts[index].quantity || 1, 10) > 1) {
      updatedProducts[index].quantity =
        parseInt(updatedProducts[index].quantity, 10) - 1;
      const isContactLens = String(updatedProducts[index].ca_id) === "3";
      updatedProducts[index].total_price =
        updatedProducts[index].quantity *
        (isContactLens
          ? parseFloat(updatedProducts[index].price_without_gst || 0)
          : parseFloat(updatedProducts[index].price_with_gst || 0));
      if (!isLoggedIn) {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        const updatedCart = localCart.map((cartItem) =>
          String(cartItem.product_id) ===
          String(updatedProducts[index].product_id)
            ? { ...cartItem, quantity: updatedProducts[index].quantity }
            : cartItem
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart));
      } else {
        const success = await updateCartQuantityAPI(
          updatedProducts[index].id,
          updatedProducts[index].quantity
        );
        if (!success) return;
      }
      setProducts(updatedProducts);
      // Check bundle offer conditions after quantity decrease
      checkBundleOfferConditions(updatedProducts);
    }
  };
  // Prescription handling functions
  const handlePrescriptionSelect = (product) => {
    setSelectedProductForPrescription(product);
    setShowPrescriptionSelector(true);
  };
  const handlePrescriptionConfirm = async (prescription) => {
    if (!selectedProductForPrescription) return;
    const productKey = selectedProductForPrescription.id || selectedProductForPrescription.product_id;
    // Convert prescription from saved format to cart format
    let prescriptionData = null;
    if (prescription) {
      prescriptionData = {
        right: {
          sph: prescription.right_sph || '',
          cyl: prescription.right_cyl || '',
          axis: prescription.right_axis || '',
          add: prescription.right_add || ''
        },
        left: {
          sph: prescription.left_sph || '',
          cyl: prescription.left_cyl || '',
          axis: prescription.left_axis || '',
          add: prescription.left_add || ''
        },
        pd: prescription.pd || '',
        rightPD: prescription.right_pd || '',
        leftPD: prescription.left_pd || '',
        hasTwoPD: prescription.has_two_pd || false
      };
    }
    // Update local state
    setProductPrescriptions(prev => ({
      ...prev,
      [productKey]: prescriptionData
    }));
    // Update cart in backend if logged in
    if (isLoggedIn && selectedProductForPrescription.id) {
      try {
        const response = await api_services.updateCartPrescription(
          selectedProductForPrescription.id,
          prescriptionData
        );
        if (response.success) {
          // toast.success(prescription ? "Prescription added to cart item!" : "Prescription removed from cart item!");
          // Update the products array to reflect the new prescription
          setProducts(prev => prev.map(product =>
            product.id === selectedProductForPrescription.id
              ? { ...product, prescription: prescriptionData ? JSON.stringify(prescriptionData) : null }
              : product
          ));
        }
      } catch (error) {
        console.error("Error updating cart prescription:", error);
        // toast.error("Failed to update prescription");
      }
    } else {
      // Update localStorage for non-logged-in users
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      const updatedCart = localCart.map((cartItem) =>
        String(cartItem.product_id) === String(selectedProductForPrescription.product_id)
          ? { ...cartItem, prescription_data: prescriptionData }
          : cartItem
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      // toast.success(prescription ? "Prescription added to cart item!" : "Prescription removed from cart item!");
    }
    setSelectedProductForPrescription(null);
  };
  const handleViewPrescription = async (prescriptionData, productName) => {
    try {
      // If prescription has a file path
      if (prescriptionData?.prescriptionFilePath) {
        const filePath = prescriptionData.prescriptionFilePath;
        try {
          // Always use the API to fetch the file, whether it's a local path or URL
          const response = await api_services.getPrescriptionFile(filePath);
          
          // Check if the response contains the expected structure
          if (response && response.data && response.contentType) {
            // Ensure data is actually a Blob
            if (response.data instanceof Blob) {
              const fileUrl = URL.createObjectURL(response.data);
              setSelectedPrescriptionData({
                ...prescriptionData,
                fileUrl,
                fileType: response.contentType,
                isLocalPath: false,
                error: null
              });
            } else {
              throw new Error('Invalid file blob received from API');
            }
          } else {
            throw new Error('Invalid response structure from API');
          }
        } catch (error) {
          console.error('Error loading prescription file through API:', error);
          
          // If API fails, show the path with an error message
          setSelectedPrescriptionData({
            ...prescriptionData,
            fileUrl: filePath,
            fileType: 'local/file',
            isLocalPath: true,
            error: 'Failed to load file. ' + (error.message || 'Please try again later.')
          });
        }
      } else {
        // If no file path, just set the prescription data as is
        setSelectedPrescriptionData(prescriptionData);
      }
      
      setSelectedProductName(productName);
      setShowPrescriptionModal(true);
    } catch (error) {
      console.error('Error in handleViewPrescription:', error);
      
      // Fallback: try to show the local path if available
      if (prescriptionData?.prescriptionFilePath) {
        setSelectedPrescriptionData({
          ...prescriptionData,
          fileUrl: prescriptionData.prescriptionFilePath,
          fileType: 'local/file',
          isLocalPath: true,
          error: 'Failed to load prescription file: ' + (error.message || 'Unknown error')
        });
      } else {
        setSelectedPrescriptionData(prescriptionData);
      }
      
      setSelectedProductName(productName);
      setShowPrescriptionModal(true);
    }
  };
  return (
    <div className="bg-gray-50 min-h-screen pb-10">
      <div className="bg-[#1F509A] text-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-2 mt-2 text-sm">
            <Link to="/" className="hover:text-[#FFD700] transition-colors">Home</Link>
            <span>›</span>
            <span className="text-[#FFD700]">Cart</span>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-4 sm:py-8">
        {products.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-8">
            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-4 sm:mb-6">
                <div className="p-4 sm:p-6 border-b border-gray-100">
                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-0">
                    <h2 className="text-xl sm:text-2xl font-bold text-[#1F509A]">
                      Cart Items ({products.length})
                    </h2>
                    {/* <Link to="/" className="text-[#1F509A] hover:underline flex items-center gap-2 text-sm font-medium self-start sm:self-auto bg-blue-50 px-3 py-2 rounded-lg hover:bg-blue-100 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                      </svg>
                      Continue Shopping
                    </Link> */}
                  </div>
                </div>
                <div className="divide-y divide-gray-100">
                  {products.map((item, index) => {
                    const isContactLens = String(item.ca_id) === "3";
                    let displayedImage;
                    if (item.is_bundle_offer && item.image_url) {
                      // For bundle offer items, use the full image URL directly
                      displayedImage = item.image_url;
                    } else {
                      // For regular items
                      const images = isContactLens
                        ? item.contact_lens_images?.split(",") || []
                        : (item.pr_image_json || item.pr_image)?.split(",") || [];
                      displayedImage = `${imageBaseURL}/${
                        images[item.selected_image_to_show || 0]
                      }`;
                    }
                    const name = isContactLens ? item.contact_lens_name : item.name;
                    const description = item.is_bundle_offer
                      ? (item.p_desc || "Premium bundle offer item")
                      : (isContactLens
                        ? item.contact_lens_description
                        : item.slug);
                    const lensType = item.lens_type_name || "N/A";
                    const lensPackage = item.lens_package_name || "N/A";
                    return (
                      <div
                        key={item.id + index}
                        className="p-4 sm:p-6 relative"
                      >
                        {/* Mobile Layout */}
                        <div className="block md:hidden">
                          <div className="flex gap-3 mb-4">
                            <div className="relative w-20 h-20 bg-gray-50 rounded-lg overflow-hidden flex-shrink-0">
                              <img
                                src={displayedImage}
                                alt={name}
                                className="w-full h-full object-contain"
                                onError={(e) => {
                                  e.target.src = "https://via.placeholder.com/150";
                                }}
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex justify-between items-start mb-2">
                                <h2 className="font-semibold text-sm text-[#1F509A] leading-tight pr-2">{name}</h2>
                                <button
                                  className="text-gray-400 hover:text-red-500 transition-colors flex-shrink-0"
                                  onClick={() => handleRemove(item)}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                              {item.is_bundle_offer && (
                                <span className="inline-block bg-green-100 text-green-600 px-2 py-1 rounded-full text-xs font-medium mb-2">
                                  Bundle Offer
                                </span>
                              )}
                              <p className="text-gray-500 text-xs leading-tight line-clamp-2 mb-2">{description}</p>
                              <div className="flex justify-between items-center">
                                <span className="text-lg font-bold text-[#1F509A]">
                                  ₹{item.total_price ? item.total_price.toFixed(2) : "0.00"}
                                </span>
                                {!isContactLens && (
                                  <span className="text-xs text-gray-500">
                                    (Incl. ₹{((item.price_without_gst || 0) * 0.18).toFixed(2)} GST)
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Desktop Layout */}
                        <div className="hidden md:flex gap-4">
                          <div className="relative w-32 h-32 bg-gray-50 rounded-lg overflow-hidden flex-shrink-0">
                            <img
                              src={displayedImage}
                              alt={name}
                              className="w-full h-full object-contain"
                              onError={(e) => {
                                e.target.src = "https://via.placeholder.com/150";
                              }}
                            />
                          </div>
                          <div className="flex-1">
                            <div className="flex justify-between items-start mb-2">
                              <div className="flex-1 pr-4 min-w-0">
                                <h2 className="font-semibold text-lg text-[#1F509A] leading-tight">{name}</h2>
                                {item.is_bundle_offer && (
                                  <span className="inline-block bg-green-100 text-green-600 px-2 py-1 rounded-full text-xs font-medium mt-1">
                                    Bundle Offer
                                  </span>
                                )}
                              </div>
                              <button
                                className="text-gray-400 hover:text-red-500 transition-colors flex-shrink-0"
                                onClick={() => handleRemove(item)}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </div>
                            <p className="text-gray-500 text-sm mt-1 line-clamp-2 mb-3">{description}</p>
                            <div className="flex justify-between items-end">
                              <div className="flex flex-col gap-1">
                                <span className="text-xl font-bold text-[#1F509A]">
                                  ₹{item.total_price ? item.total_price.toFixed(2) : "0.00"}
                                </span>
                                {!isContactLens && (
                                  <span className="text-xs text-gray-500">
                                    (Incl. ₹{((item.price_without_gst || 0) * 0.18).toFixed(2)} GST)
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Common content for both layouts */}
                        <div className="mt-4 space-y-3">
                          {/* Contact Lens Quantity Controls */}
                          {isContactLens && (
                            <div className="flex items-center justify-between sm:justify-start flex-wrap gap-2 p-3 bg-gray-50 rounded-lg">
                              <span className="text-gray-600 text-sm font-medium">Quantity:</span>
                              <div className="flex items-center border border-gray-200 rounded-lg bg-white">
                                <button
                                  className="px-3 py-2 text-[#1F509A] hover:bg-gray-50 transition-colors rounded-l-lg"
                                  onClick={() => handleDecrease(index)}
                                  disabled={parseInt(item.quantity || 1, 10) <= 1}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                                  </svg>
                                </button>
                                <span className="font-medium px-4 py-2 border-x border-gray-200 text-sm min-w-[40px] text-center">
                                  {item.quantity || 1}
                                </span>
                                <button
                                  className="px-3 py-2 text-[#1F509A] hover:bg-gray-50 transition-colors rounded-r-lg"
                                  onClick={() => handleIncrease(index)}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          )}
                          {/* Lens Information */}
                          {isLoggedIn && !isContactLens && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 p-3 bg-gray-50 rounded-lg">
                              <div className="flex items-center justify-between sm:justify-start">
                                <span className="text-gray-600 text-sm font-medium">Type:&nbsp;</span>
                                <span className="font-semibold text-[#1F509A] text-sm">{lensType}</span>
                              </div>
                              <div className="flex items-center justify-between sm:justify-start">
                                <span className="text-gray-600 text-sm font-medium">Package:&nbsp;</span>
                                <span className="font-semibold text-[#1F509A] text-sm">{lensPackage}</span>
                              </div>
                            </div>
                          )}
                          {/* Prescription Section */}
                          { (
                            <div>
                              {(() => {
                                // Check if prescription exists in parsed data or direct prescription field
                                const prescriptionData = productPrescriptions[item.id || item.product_id] ||
                                  (item.prescription && item.prescription.trim() !== '' ?
                                    (() => {
                                      try {
                                        return JSON.parse(item.prescription);
                                      } catch (e) {
                                        console.error("Error parsing prescription:", e);
                                        return null;
                                      }
                                    })() : null);
                                if (prescriptionData) {
                                  return (
                                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                          <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                                            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />
                                            </svg>
                                          </div>
                                          <span className="text-sm font-semibold text-green-800">
                                            Prescription Added
                                          </span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                          <button
                                            onClick={() => handleViewPrescription(prescriptionData, item.productName)}
                                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                                          >
                                            View Details
                                          </button>
                                          {/* <button
                                            onClick={() => handlePrescriptionSelect(item)}
                                            className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                                          >
                                            Change
                                          </button> */}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else {
                                  // return (
                                  //   // <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4">
                                  //   //   <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                                  //   //     <div className="flex items-center gap-2">
                                  //   //       <div className="w-5 h-5 bg-amber-500 rounded-full flex items-center justify-center">
                                  //   //         <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  //   //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                  //   //         </svg>
                                  //   //       </div>
                                  //   //       {/* <div>
                                  //   //         <span className="text-sm font-semibold text-amber-800 block">
                                  //   //           No Prescription
                                  //   //         </span>
                                  //   //         <span className="text-xs text-amber-700">
                                  //   //           Add your prescription for accurate lens fitting
                                  //   //         </span>
                                  //   //       </div> */}
                                  //   //     </div>
                                  //   //     {/* <button
                                  //   //       onClick={() => handlePrescriptionSelect(item)}
                                  //   //       className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors w-full sm:w-auto"
                                  //   //     >
                                  //   //       Add Prescription
                                  //   //     </button> */}
                                  //   //   </div>
                                  //   // </div>
                                  // );
                                }
                              })()}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* Bundle Offers Section - Only show for logged-in users */}
              {isLoggedIn && (showBundleOffer || showAddSolution) && !hasGenieSolution && bundleOfferData && (
                <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                  <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white p-3 sm:p-4">
                    <h3 className="text-base sm:text-lg font-bold flex items-center gap-2">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                      </svg>
                      <span className="leading-tight">
                        Special Add-on Offer
                      </span>
                    </h3>
                  </div>
                  <div className="p-3 sm:p-4">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                      <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
                        {bundleOfferData?.productData?.image_url ? (
                          <img
                            src={bundleOfferData.productData.image_url}
                            alt={bundleOfferData.productName}
                            className="w-full h-full object-contain"
                            onError={(e) => {
                              e.target.src = "https://via.placeholder.com/64";
                            }}
                          />
                        ) : (
                          <svg className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                          </svg>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-gray-800 text-sm sm:text-base">{bundleOfferData.productName}</h4>
                        <p className="text-xs sm:text-sm text-gray-600 mt-1 leading-tight">
                          {bundleOfferData.productData?.p_desc || "Premium formula for crystal clear vision. Safe for all lens types"}
                        </p>
                        <div className="flex items-center gap-2 mt-2 flex-wrap">
                          <span className="text-gray-400 line-through text-sm">₹{bundleOfferData.original_price}</span>
                          <span className="text-green-600 font-bold text-sm sm:text-base">₹{bundleOfferData.value}</span>
                          <span className="bg-red-100 text-red-600 px-2 py-1 rounded-full text-xs font-medium">
                            {bundleOfferData.discount || 50}% OFF
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={addLensCleaningSolution}
                        className="w-full sm:w-auto bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-200 shadow-lg text-sm sm:text-base whitespace-nowrap"
                      >
                        Add for ₹{bundleOfferData.value}
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* New Customer Welcome Message */}
              {isNewCustomer && (
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-3 sm:p-4 mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                      </svg>
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-base sm:text-lg font-bold text-blue-800 leading-tight">Welcome to SpectGenie! 🎉</h3>
                      <p className="text-blue-700 text-xs sm:text-sm leading-tight">
                        As a new customer, enjoy 10% off with code <span className="font-bold">GENIENEW</span>
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-sm overflow-hidden sticky top-6">
                <div className="p-4 sm:p-6 border-b border-gray-100">
                  <h2 className="text-lg sm:text-xl font-bold text-[#1F509A]">
                    Order Summary
                  </h2>
                </div>
                <div className="p-4 sm:p-6 space-y-4">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Subtotal</span>
                    <span className="font-medium">₹{(originalTotalAmt || 0).toFixed(2)}</span>
                  </div>
                  <div className="py-4 border-b border-gray-100">
                    {appliedCoupon ? (
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <div className="flex items-center">
                            <span className="bg-[#f0f4ff] text-[#1F509A] px-2 py-1 rounded text-sm font-medium">
                              {appliedCoupon.code}
                            </span>
                            <button
                              onClick={removeCoupon}
                              className="ml-2 text-red-500 hover:text-red-600 text-sm"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                          <span className="text-green-600 font-medium">
                            -₹{(appliedCoupon.discount || 0).toFixed(2)}
                          </span>
                        </div>
                        <p className="text-xs text-gray-500">
                          Applied to {appliedCoupon.applicableProducts} product(s) worth ₹{(appliedCoupon.categoryTotal || 0).toFixed(2)}
                        </p>
                      </div>
                    ) : (
                      <button
                        className="flex items-center gap-2 text-[#1F509A] hover:text-[#000055] transition-colors w-full"
                        onClick={() => setCouponModalOpen(true)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        <span className="font-medium">Apply Coupon</span>
                      </button>
                    )}
                  </div>
                  {/* SG-Wallet Points Section */}
                  {isLoggedIn && availablePoints > 0 && (
                    <div className="py-4 border-b border-gray-100">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <svg className="w-5 h-5 text-[#1F509A] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                          </svg>
                          <span className="font-medium text-[#1F509A] text-sm sm:text-base">SG-Wallet Points</span>
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600 self-start sm:self-center">
                          {appliedPoints > 0 ? (
                            <div className="flex flex-col gap-1">
                              <span className="text-gray-400 line-through">Original: ₹{availablePoints || 0}</span>
                              <span className="text-green-600 font-medium">Available: ₹{(availablePoints - (appliedPoints || 0)) || 0}</span>
                            </div>
                          ) : (
                            <span>Available: ₹{availablePoints || 0}</span>
                          )}
                        </div>
                      </div>
                      <div className="space-y-3">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                          <label className="flex items-center gap-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={useWalletPoints}
                              onChange={handleWalletPointsChange}
                              className="w-4 h-4 text-[#1F509A] bg-gray-100 border-gray-300 rounded focus:ring-[#1F509A] focus:ring-2 flex-shrink-0"
                            />
                            <span className="text-sm font-medium text-gray-700">
                              Use SG-Wallet Points
                            </span>
                          </label>
                          {appliedPoints > 0 && (
                            <span className="text-green-600 font-medium text-sm self-start sm:self-center">
                              -₹{(appliedPoints || 0).toFixed(2)}
                            </span>
                          )}
                        </div>
                        {appliedPoints > 0 && (
                          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                            <span className="bg-[#f0f4ff] text-[#1F509A] px-2 py-1 rounded text-xs sm:text-sm font-medium self-start">
                              ₹{appliedPoints || 0} Applied
                            </span>
                            <span className="text-xs text-gray-500 sm:text-right">
                              Maximum usable: ₹{Math.min(availablePoints || 0, totalAmt || 0)}
                            </span>
                          </div>
                        )}
                        {appliedPoints > 0 && (
                          <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                            <p className="text-xs text-green-700 leading-relaxed font-medium">
                              ✅ Using ₹{appliedPoints || 0} from your SG-Wallet
                            </p>
                            <p className="text-xs text-green-600 mt-1">
                              Remaining balance: ₹{(availablePoints - (appliedPoints || 0)) || 0}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {/* Order Summary Breakdown */}
                  {(appliedCoupon || appliedPoints > 0) && (
                    <div className="space-y-2 py-3 border-b border-gray-100">
                      {appliedCoupon && (
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">After Coupon</span>
                          <span className="font-medium">₹{(totalAmt || 0).toFixed(2)}</span>
                        </div>
                      )}
                      {appliedPoints > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Points Discount</span>
                          <span className="font-medium text-green-600">-₹{(appliedPoints || 0).toFixed(2)}</span>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="flex justify-between items-center py-2">
                    <span className="text-lg font-bold text-gray-800">Final Total</span>
                    <span className="text-xl font-bold text-[#1F509A]">₹{(finalAmount || 0).toFixed(2)}</span>
                  </div>
                  {!isLoggedIn ? (
                    <button
                      onClick={handlePayment}
                      className="w-full py-3 mt-4 bg-[#1F509A] hover:bg-[#000055] text-white rounded-lg transition-colors duration-300 font-medium flex items-center justify-center gap-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                      </svg>
                      Login to Checkout
                    </button>
                  ) : (
                    <div className="space-y-4 mt-6">
                      <div className="border-t border-gray-100 pt-4">
                        <h3 className="text-lg font-semibold text-[#1F509A] mb-3 flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          Delivery Address
                        </h3>
                        <button
                          className="flex items-center gap-2 text-[#1F509A] hover:text-[#000055] transition-colors mb-3 text-sm font-medium"
                          onClick={() => setModalOpen(true)}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          Add New Address
                        </button>
                        <div className="max-h-48 overflow-y-auto scrollable-addresses space-y-3">
                          {addresses.length > 0 ? (
                            addresses.map((address) => (
                              <div
                                key={address.id}
                                className={`p-3 border rounded-lg cursor-pointer transition-all duration-300 ${
                                  selectedAddress?.id === address.id
                                    ? "border-[#1F509A] bg-[#f8f9ff]"
                                    : "border-gray-200 hover:border-gray-300"
                                }`}
                                onClick={() => handleSelect(address)}
                              >
                                <div className="flex items-start gap-3">
                                  <input
                                    type="radio"
                                    id={address.id}
                                    name="address"
                                    checked={selectedAddress?.id === address.id}
                                    onChange={() => {}}
                                    className="mt-1 accent-[#1F509A]"
                                  />
                                  <div>
                                    <p className="font-medium">{address.address_name}</p>
                                    <p className="text-sm text-gray-600 mt-1">
                                      {address.address_line_1}, {address.address_line_2}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                      {address.city}, {address.state}, {address.country} - {address.pincode}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-center py-4 text-gray-500">
                              No addresses found. Please add a delivery address.
                            </div>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={handlePayment}
                        className={`w-full py-3 rounded-lg font-medium flex items-center justify-center gap-2 transition-all duration-300 ${
                          selectedAddress
                            ? "bg-[#1F509A] hover:bg-[#000055] text-white"
                            : "bg-gray-200 text-gray-400 cursor-not-allowed"
                        }`}
                        disabled={!selectedAddress}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        Proceed to Payment
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col items-center py-12 sm:py-20 bg-white rounded-lg shadow-sm p-6 sm:p-10 max-w-2xl mx-auto"
          >
            <div className="w-24 h-24 sm:w-32 sm:h-32 mb-4 sm:mb-6 text-[#1F509A] opacity-30">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h1 className="font-bold text-xl sm:text-2xl mb-2 text-[#1F509A] text-center">
              Your Cart is Empty!
            </h1>
            <p className="text-gray-500 text-center max-w-md mb-6 text-sm sm:text-base px-4 sm:px-0">
              Looks like you haven't added any products to your cart yet. Browse our collection and find something you'll love.
            </p>
            <Link
              to="/"
              state={{ message: "Continue shopping to add items to your cart." }}
              className="inline-block w-full sm:w-auto"
            >
              <button className="w-full sm:w-auto bg-[#1F509A] text-white px-6 sm:px-8 py-3 rounded-lg hover:bg-[#000055] transition-colors duration-300 font-medium flex items-center justify-center gap-2 text-sm sm:text-base">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                Start Shopping
              </button>
            </Link>
          </motion.div>
        )}
      </div>
      {isModalOpen && (
        <AddAddress
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          isEditing={false}
          onSave={handleSaveAddress}
        />
      )}
      {isCouponModalOpen && (
        <CouponModal
          onClose={() => setCouponModalOpen(false)}
          setTotalAmount={setTotalAmt}
          totalAmount={totalAmt}
          setAppliedCoupon={setAppliedCoupon}
          products={products}
          isLoggedIn={isLoggedIn}
          applyCoupon={applyCoupon}
        />
      )}
      <style jsx>{`
        .scrollable-addresses::-webkit-scrollbar {
          width: 8px;
        }
        .scrollable-addresses::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .scrollable-addresses::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        .scrollable-addresses::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
      {/* Prescription Selector Modal */}
      {/* <PrescriptionSelector
        isOpen={showPrescriptionSelector}
        onClose={() => {
          setShowPrescriptionSelector(false);
          setSelectedProductForPrescription(null);
        }}
        onSelect={handlePrescriptionConfirm}
        currentPrescription={selectedProductForPrescription ?
          productPrescriptions[selectedProductForPrescription.id || selectedProductForPrescription.product_id] ||
          selectedProductForPrescription.prescription_data : null}
        productId={selectedProductForPrescription?.id || selectedProductForPrescription?.product_id}
      /> */}
      {/* Prescription Modal */}
      <PrescriptionModal
        isOpen={showPrescriptionModal}
        onClose={() => setShowPrescriptionModal(false)}
        prescriptionData={selectedPrescriptionData}
        productName={selectedProductName}
      />
    </div>
  );
};
export default Cart;